<template>
  <el-tooltip :content="tooltipContent" placement="bottom">
    <el-tag>{{ office ? office.efin : '' }}</el-tag>
  </el-tooltip>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Office from '@/model/Office';
import OfficeToRefType from '@/util/OfficeToRefType';

export default {
  props: {
    officeId: {
      type: Number,
      default: undefined,
    },
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
  },
  computed: {
    ...mapGetters('Lookup', [
      'officeMap',
    ]),
    office() {
      if (this.officeId !== undefined) {
        return this.officeMap[this.officeId];
      }
      return new Office();
    },
    refType() {
      if (this.office) {
        return OfficeToRefType(this.office);
      }
      return undefined;
    },
    tooltipContent() {
      if (this.refType !== undefined) {
        return this.refType.name;
      }
      return '';
    },
  },
  mounted() {
    this.getOffices();
  },
};

</script>
